import PropTypes from 'prop-types';
import React from 'react';
import InputField from './InputField';
import DateTimeWidget from './AsyncDateTimeWidget';
import TextareaWithUploader from './AsyncTextareaWithUploader';

const typeMap = {
  email: 'email',
  phone: 'tel',
  text: 'text',
  url: 'url',
  zipcode_us: 'text',
  numeric: 'number',
};

const OpenWidget = ({ uploaderConfig, ...props }) => {
  switch (props.field_type) {
    case 'essay':
      return <TextareaWithUploader {...props} {...uploaderConfig} />;
    case 'date':
      return <DateTimeWidget {...props} />;
    case 'time':
      return <DateTimeWidget {...props} />;
    case 'datetime':
      return <DateTimeWidget {...props} />;
    default:
      return <InputField {...props} type={typeMap[props.field_type]} />;
  }
};

OpenWidget.propTypes = {
  field_type: PropTypes.oneOf([
    'date',
    'datetime',
    'email',
    'essay',
    'phone',
    'text',
    'time',
    'url',
    'zipcode_us',
    'numeric',
  ]).isRequired,
  uploaderConfig: PropTypes.object,
};

OpenWidget.defaultProps = {
  field_type: 'text',
};

export default OpenWidget;
